var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-main"},[_c('HeaderBar',{attrs:{"text":_vm.life.header,"backgroundUrl":_vm.life.headerUrl}}),_vm._v(" "),_c('MySchool',{attrs:{"mySchool":_vm.life.mySchool}}),_vm._v(" "),_c('Course',{attrs:{"course":_vm.life.course}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7f9f8a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/STUDENTS/Life.vue
// module id = null
// module chunks = 